import React from 'react';
import { motion } from 'framer-motion';
import { Home, Sprout } from 'lucide-react';
export function Intro() {
  return <section className="w-full py-8 md:py-16 px-4 bg-white" data-id="element-136">
      <div className="max-w-4xl mx-auto text-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-6 md:mb-8" data-id="element-138">
          <div className="flex items-center justify-center gap-2 mb-3 md:mb-4" data-id="element-139">
            <Home className="w-5 h-5 md:w-6 md:h-6 text-green-700" data-id="element-140" />
            <h2 className="text-xl md:text-3xl font-bold text-gray-900 leading-tight" data-id="element-141">
              🏠 Para personas que quieren gastar menos y comer mejor
            </h2>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-142">
          <div className="flex items-center justify-center gap-2 mb-3 md:mb-4" data-id="element-143">
            <Sprout className="w-5 h-5 md:w-6 md:h-6 text-lime-600" data-id="element-144" />
            <h3 className="text-lg md:text-2xl font-bold text-green-800" data-id="element-145">
              🌱 ¿Qué incluye Huerta Express 30D?
            </h3>
          </div>
          <p className="text-base md:text-lg text-gray-700 font-medium" data-id="element-146">
            Dentro de HUERTA EXPRESS 30D encontrás todo lo que necesitás para
            empezar desde cero y ver resultados reales en tu casa.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-6 md:mt-8 border-t-2 border-b-2 border-green-100 py-4 bg-green-50/50 rounded-xl" data-id="element-147">
          <p className="text-xs md:text-sm font-bold text-green-800 uppercase tracking-widest" data-id="element-148">
            ✦ LO QUE INCLUYE EL SISTEMA ✦
          </p>
          <p className="text-xs md:text-sm text-gray-600 mt-2 font-medium" data-id="element-149">
            Sistema completo · Acceso inmediato · Descarga digital · Listo para
            empezar hoy
          </p>
        </motion.div>
      </div>
    </section>;
}